import { render, staticRenderFns } from "./InputUserSalary.vue?vue&type=template&id=491518f2&"
import script from "./InputUserSalary.vue?vue&type=script&lang=js&"
export * from "./InputUserSalary.vue?vue&type=script&lang=js&"
import style0 from "./InputUserSalary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InputUserSalary.vue"
export default component.exports